import React from 'react';
import { getComputedCSSVariable } from '../../../../utils/cssVariableHelpers';

interface Props {
  color?: string,
  style?: object,
}

const EditSVG: React.FC<Props> = ({
  color,
  style,
}) => {
  return (
    <span
      className="d-flex svg-wrapper"
      style={style}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 64 64"
        aria-labelledby="title"
        aria-describedby="desc"
        role="img"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <path
          data-name="layer1"
          fill="none"
          stroke={color}
          strokeMiterlimit="10"
          strokeWidth="4"
          d="M56 2.4l-26.1 26-4 9.7 9.7-4.1 26-26L56 2.4z"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        <path
          data-name="layer2"
          fill="none"
          stroke={color}
          strokeMiterlimit="10"
          strokeWidth="4"
          d="M34.4 11.6h-32v50h50v-32"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        <path
          data-name="layer1"
          fill="none"
          stroke={color}
          strokeMiterlimit="10"
          strokeWidth="4"
          d="M50.8 7.6l5.6 5.6"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </svg>
    </span>
  );
};

EditSVG.defaultProps = {
  color: getComputedCSSVariable('black'),
  style: {
    width: '9px',
    height: '9px',
  },
};

export default EditSVG;
